<script setup lang="ts">
import { ToastProvider } from '@brighterly/lib-lumee-ui'

defineOptions({
  name: 'App',
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>

  <ToastProvider />
</template>
